export default class Sponsor {
  constructor () {
    this.setInitialValue()
  }

  setInitialValue () {
    this.logo = ''
    this.logoUrl = null
    this.url = ''
    this.translations = [
      { id: null, name: '', banner_text: '', lang: 'ar' },
      { id: null, name: '', banner_text: '', lang: 'en' }
    ]
  }

  fillData (data) {
    if (data) {
      const itemAr = data.translations?.find(o => o.lang === 'ar')
      const itemEn = data.translations?.find(o => o.lang === 'en')

      this.logoUrl = data.logo ? data.logo : null
      this.url = data.url ? data.url : ''
      this.translations[0].id = itemAr ? itemAr.id : null
      this.translations[0].name = itemAr ? itemAr.name : ''
      this.translations[0].banner_text = itemAr ? itemAr.banner_text : ''
      this.translations[1].id = itemEn ? itemEn.id : null
      this.translations[1].name = itemEn ? itemEn.name : ''
      this.translations[1].banner_text = itemEn ? itemEn.banner_text : ''
    } else {
      this.setInitialValue()
    }
  }
}
